import styled from 'styled-components';

import * as selfVars from './StepNumber.styles.vars';

export const Container = styled.span(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,

  inlineSize: selfVars.iconSize,
  blockSize: selfVars.iconSize,
  borderRadius: '50%',
  background: theme.header.primaryAccent.bg,

  color: theme.header.primaryAccent.text,
  fontFamily: theme.typography.family.arial,
  fontWeight: 'bold',
}));
